import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

const SimulatorSwitcher = ({ simulatorAssetContainer, simulatorFinancialContainer, hasFinancial }) => (
  <Switch>
    <Route exact path="/simulator" render={() => <Redirect to="/simulator/assetSelection" />} />
    <Route exact path="/simulator/assetSelection" render={simulatorAssetContainer} />
    <Route
      exact
      path="/simulator/offer"
      render={() => (hasFinancial ? simulatorFinancialContainer() : <Redirect to="/simulator/assetSelection" />)}
    />
    <Route render={() => <Redirect to="/notFound" />} />
  </Switch>
);

SimulatorSwitcher.propTypes = {
  simulatorAssetContainer: PropTypes.func.isRequired,
  simulatorFinancialContainer: PropTypes.func.isRequired,
  hasFinancial: PropTypes.bool.isRequired
};

export default SimulatorSwitcher;
